import { create } from 'zustand';

const MAX_ACTIVITY_ENTRIES = 100;

export const useNexusStore = create((set, get) => ({
  // Auth
  user: JSON.parse(localStorage.getItem('nexus_user') || 'null'),
  token: localStorage.getItem('nexus_token') || null,
  isAuthenticated: !!localStorage.getItem('nexus_token'),

  setAuth: (token, user) => {
    localStorage.setItem('nexus_token', token);
    localStorage.setItem('nexus_user', JSON.stringify(user));
    set({ token, user, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('nexus_token');
    localStorage.removeItem('nexus_user');
    set({ token: null, user: null, isAuthenticated: false });
  },

  // Agent statuses
  agentStatuses: {},
  activityFeed: [],
  ticketUpdates: [],
  isConnected: false,
  kpis: null,
  navBadges: { incidents: 0, changes: 0, requests: 0, problems: 0, assets: 0, agents: 10, knowledge: 0, analytics: 0 },

  setConnected: (connected) => set({ isConnected: connected }),
  updateAgentStatus: (statusData) => set((state) => ({
    agentStatuses: { ...state.agentStatuses, [statusData.agent_name]: { ...state.agentStatuses[statusData.agent_name], ...statusData } }
  })),
  addActivityEntry: (entry) => set((state) => ({ activityFeed: [entry, ...state.activityFeed].slice(0, MAX_ACTIVITY_ENTRIES) })),
  setActivityFeed: (feed) => set({ activityFeed: feed }),
  addTicketUpdate: (update) => set((state) => ({ ticketUpdates: [update, ...state.ticketUpdates].slice(0, 50) })),
  setKpis: (kpis) => set({ kpis }),
  setNavBadges: (badges) => set({ navBadges: badges }),
}));
